import { render, staticRenderFns } from "./PersonalizationMicrosoftStep2.vue?vue&type=template&id=5b730257&scoped=true"
import script from "./PersonalizationMicrosoftStep2.vue?vue&type=script&lang=js"
export * from "./PersonalizationMicrosoftStep2.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationMicrosoftStep2.vue?vue&type=style&index=0&id=5b730257&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b730257",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b730257')) {
      api.createRecord('5b730257', component.options)
    } else {
      api.reload('5b730257', component.options)
    }
    module.hot.accept("./PersonalizationMicrosoftStep2.vue?vue&type=template&id=5b730257&scoped=true", function () {
      api.rerender('5b730257', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/personalization/microsoft/PersonalizationMicrosoftStep2.vue"
export default component.exports